export default "__VITE_ASSET__p7C67k8$__"